<mat-toolbar class="accordion-header-contents">
  {{ (opportunity$ | async)?.name }}
  <mat-icon id="close-nav" (click)="closeSideNav()">close</mat-icon>
</mat-toolbar>

<ng-container *ngIf="showActivities$ | async; else details">
  <mat-tab-group mat-stretch-tabs>
    <mat-tab [label]="'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.DETAILS' | translate">
      <ng-container *ngTemplateOutlet="details" />
    </mat-tab>
    <mat-tab [label]="'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.ACTIVITY' | translate">
      <sales-ui-opportunity-activities [opportunity]="opportunity$ | async" />
    </mat-tab>
  </mat-tab-group>
</ng-container>

<ng-template #details>
  <mat-accordion class="details-accordion">
    <mat-expansion-panel [expanded]="(mode$ | async) === 'details'">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.OPPORTUNITY_INFO' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <!--      TODO: Add partner preferred currency-->
      <sales-ui-opportunity-info [opportunity]="opportunity$ | async" [preferredCurrency]="'USD'" />
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.ACCOUNT_INFO' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <sales-ui-business-info [pipelineBoardSlideoutStyling]="true" [businessId]="accountGroupId$ | async" />
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header (click)="handleQualificationClicked()">
        <mat-panel-title>
          {{ 'FRONTEND.SALES_UI.PIPELINE.COLUMN_LABELS.OPPORTUNITY_QUALIFICATION' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-container *ngIf="(mode$ | async) === 'qualification'">
        <sales-ui-opportunity-qualification [opportunity]="opportunity$ | async" />
      </ng-container>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'FRONTEND.SALES_UI.COMMON.NOTES' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <sales-ui-opportunity-notes
        *ngIf="forceReload$ | async"
        [loading]="updateNoteLoading$$ | async"
        (noteChanged)="updateNote($event)"
        [editable]="isEditable$ | async"
        [note]="(opportunity$ | async)?.notes"
      />
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>{{ 'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.ITEMS' | translate }}</mat-panel-title>
      </mat-expansion-panel-header>
      <div class="opportunity-items">
        <ng-container *ngIf="opportunity$ | async as opportunity">
          <sales-ui-sales-order-confirmation
            *ngIf="forceReload$ | async"
            [title]="''"
            [partnerId]="this.partnerId$ | async"
            [marketId]="this.marketId$ | async"
            [businessId]="opportunity.accountGroupId"
            [opportunityId]="opportunity.opportunityId"
            [editable]="true"
            [startEditing]="false"
            [allowNegativeValues]="true"
            [bypassQuantityRestrictions]="this.bypassQuantityRestrictions$ | async"
            [enableEditBillingSchedule]="true"
            [allowDuplicateItems]="true"
            [contractStartDate]="opportunity.expectedCloseDate"
          />
        </ng-container>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'FRONTEND.SALES_UI.OPPORTUNITY_ATTACHMENT.ATTACHMENTS' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <sales-ui-attachments-card />
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'FRONTEND.SALES_UI.OPPORTUNITY_TAGS.TITLE' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <sales-ui-opportunity-tags
        [loading]="updateTagsLoading$$ | async"
        [opportunity]="opportunity$ | async"
        (tagsChanged)="handleTagsChanged($event)"
      />
    </mat-expansion-panel>
  </mat-accordion>
</ng-template>
